/**
 * Maps unified props to web-specific attributes.
 *
 * - testID → data-testid
 * - slot → data-slot
 * - id → id
 * - liveRegion → aria-live (+ aria-atomic)
 * - pressed → aria-pressed (toggle buttons)
 */
export function platformProps({
  testID,
  slot,
  id,
  liveRegion,
  pressed,
}: {
  testID?: string;
  slot?: string;
  id?: string;
  liveRegion?: "polite" | "assertive";
  pressed?: boolean;
}) {
  return {
    ...(testID != null && { "data-testid": testID }),
    ...(slot != null && { "data-slot": slot }),
    ...(id != null && { id }),
    ...(liveRegion != null && ({ "aria-live": liveRegion, "aria-atomic": "true" } as const)),
    ...(pressed != null && { "aria-pressed": pressed }),
  };
}
